module.exports = __webpack_public_path__ + "img/InvoiceHeader.512bfdd2.svg";